import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig';

const environment = import.meta.env.MODE;

export default {
    resultImageKey: 'ai/export/image-extender/',
    originalImageKey: 'ai/input/image-extender/',
    historyListType: 9,
    freeLimitType: 'image-extender',
    currentMenuName: 'ai-image-extender',
    notImageBoxBgUrl:
        environment === LOCAL
            ? `/public/img/imageExtender/bg.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/imageExtender/bg.png?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxVideoUrl:
        environment === LOCAL
            ? `/public/img/imageExtender/video.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/imageExtender/video.mp4?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxTitle: 'quickly-jumpstart-your-creativity',
    notImageBoxDesc: 'easily-achieve-it-with-a-simple-drag-and-drop',
};
